import script from "./articulos.vue?vue&type=script&setup=true&lang=js"
export * from "./articulos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__